export default "__VITE_ASSET__EnlLrmFx__"